import { formatCurrency, getCurrencySymbol } from '@angular/common';

export const formatPrice = (
  price: number,
  locale: string,
  currency: string,
  digitsInfo?: string,
) => {
  const hasDecimals = price % 1 !== 0;
  const format = digitsInfo || (hasDecimals ? '1.2-2' : '1.0-0');
  return formatCurrency(price, locale, getCurrencySymbol(currency, 'narrow'), currency, format);
};
